import PropTypes from 'prop-types';
import './styles/formGroupStyles.css';

const FormGroup = ({ children, inline }) => (
  <div className={`mb-4 ${inline ? 'inline-form-group' : ''}`}>{children}</div>
);

FormGroup.defaultProps = {
  inline: false,
};

FormGroup.propTypes = {
  children: PropTypes.node.isRequired,
  inline: PropTypes.bool,
};

export default FormGroup;
